import { createContext, useContext } from 'react';
import { enableStaticRendering } from "mobx-react-lite";
import { ProGlobals } from 'pro/interfaces/globals';

export { makeAutoObservable } from 'mobx';
export { observer, Observer, useLocalObservable, useLocalStore } from 'mobx-react-lite';

// there is no window object on the server
enableStaticRendering(typeof window === "undefined");

type IStore = ProGlobals.IStore;

const store: IStore = {} as IStore; // 全局 store 对象
const StoreContext = createContext<IStore>({} as IStore); // 保存可观察数据的 React Context 对象

// store 初始化，仅在 _app 中使用，刷新或跳转页面时执行
export const initStore = (newStore: IStore): IStore => {
    for (const key in newStore) {
        store[key] = newStore[key];
    }
    return store;
};

// 非函数组件中获取 store 对象
export const getStore = (): IStore => store;

// 非函数组件中获取 store 模块的 state
export const getStoreState = <T extends keyof IStore>(moduleName: T): IStore[T]['state'] => {
    return store[moduleName]?.state || ({} as IStore[T]['state']);
};

export const getStoreContext = () => StoreContext;

// store hook, 获取 store 模块
export const useStore = () => useContext(StoreContext);

// store hook, 获取 store 模块的 state
export const useStoreState = <T extends keyof IStore>(moduleName: T): IStore[T]['state'] => {
    return useContext(StoreContext)[moduleName].state || ({} as IStore[T]['state']);
};

export const syncGlobalStore = <T extends keyof IStore>(moduleName: T, newState: Partial<IStore[T]['state']>) => {
    if ('update' in store[moduleName]) {
        // @ts-ignore
        store[moduleName].update?.(newState);
    }
}